interface CognitoAuthConfig {
  authority: string;
  client_id: string;
  identity_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  cognito_domain: string;
  logout_uri: string;
}

interface StageConfig {
  domainName: string;
  cognitoAuthConfig: CognitoAuthConfig;
  gamecastApiEndpoint: string;
  assetSearchConfig: {
    asinSearchLambdaName: string;
    asinSearchLambdaRegion: string;
    getAssetLambdaArn: string;
    getAssetLambdaRegion: string;
    getAssetAccountId: string;
    imageProxyUrl: string;
  };
}

interface StageConfigs {
  localhost: StageConfig;
  alpha: StageConfig;
  beta: StageConfig;
  production: StageConfig;
}

export const STAGE_CONFIG: StageConfigs = Object.freeze({
  localhost: Object.freeze({
    domainName: "localhost",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_1fVVEoQzt",
      client_id: "4a7mbr1t1kos4qsh3cdq3dc6kr",
      identity_id: "us-east-1:bb2e8ec6-bd61-4182-b778-bebf8b6218d2",
      redirect_uri: "http://localhost:3000",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-11fVVEoQzt.auth.us-east-1.amazoncognito.com",
      logout_uri: "http://localhost:3000"
    },
    gamecastApiEndpoint: "https://ytprliwm0g.execute-api.us-east-1.amazonaws.com/prod",
    assetSearchConfig: {
      asinSearchLambdaName: "ImagingCoreAssetHubResolverLambda",
      asinSearchLambdaRegion: "us-east-1",
      getAssetLambdaArn: "arn:aws:lambda:us-west-2:669392805855:function:WoodshopAssetServiceLambda-GetAssetFunction-8T3IVZ1TEJBJ",
      getAssetLambdaRegion: "us-west-2",
      getAssetAccountId: "898621781391",
      imageProxyUrl: "https://i5ym8oc9ed.execute-api.us-east-1.amazonaws.com/prod/download",
    },
  }),
  alpha: Object.freeze({
    domainName: "workbench.nahigian-designtech.amazon.dev",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_1fVVEoQzt",
      client_id: "4a7mbr1t1kos4qsh3cdq3dc6kr",
      identity_id: "us-east-1:bb2e8ec6-bd61-4182-b778-bebf8b6218d2",
      redirect_uri: "https://workbench.nahigian-designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-11fVVEoQzt.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://workbench.nahigian-designtech.amazon.dev"
    },
    gamecastApiEndpoint: "https://ytprliwm0g.execute-api.us-east-1.amazonaws.com/prod",
    assetSearchConfig: {
      asinSearchLambdaName: "ImagingCoreAssetHubResolverLambda",
      asinSearchLambdaRegion: "us-east-1",
      getAssetLambdaArn: "arn:aws:lambda:us-west-2:669392805855:function:WoodshopAssetServiceLambda-GetAssetFunction-8T3IVZ1TEJBJ",
      getAssetLambdaRegion: "us-west-2",
      getAssetAccountId: "898621781391",
      imageProxyUrl: "https://i5ym8oc9ed.execute-api.us-east-1.amazonaws.com/prod/download",
    },
  }),
  beta: Object.freeze({
    domainName: "workbench.sandbox-designtech.amazon.dev",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_2SfIQFOvN",
      client_id: "3vbe910j1evep3a2svmmihfqk3",
      identity_id: "us-east-1:f7ba04a1-6b61-4c24-8e3b-3e50768563ba",
      redirect_uri: "https://workbench.sandbox-designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-12sfiqfovn.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://workbench.sandbox-designtech.amazon.dev"
    },
    gamecastApiEndpoint: "https://o6guammmcc.execute-api.us-east-1.amazonaws.com/prod",
    assetSearchConfig: {
      asinSearchLambdaName: "ImagingCoreAssetHubResolverLambda",
      asinSearchLambdaRegion: "us-east-1",
      getAssetLambdaArn: "arn:aws:lambda:us-west-2:669392805855:function:WoodshopAssetServiceLambda-GetAssetFunction-8T3IVZ1TEJBJ",
      getAssetLambdaRegion: "us-west-2",
      getAssetAccountId: "898621781391",
      imageProxyUrl: "https://17cxd433c1.execute-api.us-east-1.amazonaws.com/prod/download",
    },
  }),
  production: Object.freeze({
    domainName: "workbench.designtech.amazon.dev",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_1fVVEoQzt",
      client_id: "4a7mbr1t1kos4qsh3cdq3dc6kr",
      identity_id: "us-east-1:bb2e8ec6-bd61-4182-b778-bebf8b6218d2",
      redirect_uri: "https://workbench.designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-11fVVEoQzt.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://workbench.designtech.amazon.dev"
    },
    gamecastApiEndpoint: "https://529e7x6mkb.execute-api.us-east-1.amazonaws.com/prod",
    assetSearchConfig: {
      asinSearchLambdaName: "ImagingCoreAssetHubResolverLambda",
      asinSearchLambdaRegion: "us-east-1",
      getAssetLambdaArn: "arn:aws:lambda:us-west-2:669392805855:function:WoodshopAssetServiceLambda-GetAssetFunction-8T3IVZ1TEJBJ",
      getAssetLambdaRegion: "us-west-2",
      getAssetAccountId: "898621781391",
      imageProxyUrl: "https://99gtpzc1l9.execute-api.us-east-1.amazonaws.com/prod/download",
    },
  })
});

export const stageConfig = (): StageConfig | undefined => {
  const domainName = window.location.hostname;
  return Object.values(STAGE_CONFIG).find(
    (config) => config.domainName === domainName
  );
};

export const getStageConfig = (): StageConfig => {
  const config = stageConfig();
  if (!config) {
    throw new Error(`No configuration found for domain: ${window.location.hostname}`);
  }
  return config;
};
